'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const MainContent = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
`;

export const MainTeacherContainer = styled.div`
  display: flex;
  gap: 2rem;
  padding: ${Spacers.BASE}rem;
  align-items: flex-start;
`;
